{
  "name": "@turnercode/cdp-psm-core",
  "version": "4.6.0",
  "description": "Prism core functions",
  "private": true,
  "main": "dist/psm.legacy.min.umd.cjs",
  "module": "dist/psm.legacy.min.umd.mjs",
  "exports": {
    ".": {
      "import": "./dist/psm.legacy.min.umd.mjs",
      "require": "./dist/psm.legacy.min.umd.cjs"
    },
    "./web": {
      "import": "./dist/psm.legacy.min.umd.mjs",
      "require": "./dist/psm.legacy.min.umd.cjs"
    },
    "./rn": {
      "import": "./dist/psm-rn.mjs",
      "require": "./dist/psm-rn.cjs"
    },
    "./src/*": "./src/*",
    "./package.json": "./package.json"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/turnercode/cdp.git",
    "directory": "packages/psm-core"
  },
  "author": "The CDP Development Team <CDP-TECH-TEAM@warnermedia.com>",
  "license": "UNLICENSED",
  "scripts": {
    "build": "tsup --minify && webpack --config webpack.es5.config.js",
    "build:modern": "tsup --minify",
    "build:es5": "webpack --config webpack.es5.config.js",
    "test:es5": "pnpm build:es5 && pnpm test:es5:contract && pnpm test:es5:smoke",
    "test:es5:contract": "node scripts/assert-es5-bundle.mjs",
    "test:es5:smoke": "node scripts/smoke-es5-eval.mjs",
    "clean": "rm -rf .turbo && rm -rf node_modules && rm -rf dist",
    "lint": "TIMING=1 eslint src --fix",
    "test": "jest"
  },
  "devDependencies": {
    "@babel/core": "^7.29.0",
    "@babel/plugin-transform-runtime": "^7.29.0",
    "@babel/preset-env": "^7.29.0",
    "@babel/preset-typescript": "^7.28.5",
    "@babel/runtime": "^7.28.6",
    "@iabtcf/cmpapi": "^1.5.6",
    "@iabtcf/core": "^1.5.6",
    "@segment/localstorage-retry": "^1.3.0",
    "@turnercode/cdp-cookie": "workspace:*",
    "@turnercode/cdp-feature-flag-client": "workspace:*",
    "@turnercode/cdp-prism-module-telemetry": "workspace:*",
    "@turnercode/eslint-config-cdp": "workspace:*",
    "@turnercode/scripts": "workspace:*",
    "@turnercode/tsconfig": "workspace:*",
    "@turnercode/types": "workspace:*",
    "babel-loader": "^10.1.0",
    "core-js": "^3.48.0",
    "es-check": "^9.6.2",
    "terser-webpack-plugin": "^5.3.17",
    "tsup": "^8.5.1",
    "uuid": "^13.0.0",
    "webpack": "^5.105.4",
    "webpack-cli": "^6.0.1"
  },
  "jest": {
    "preset": "@turnercode/scripts/jest/node",
    "testEnvironment": "jsdom",
    "testEnvironmentOptions": {}
  }
}
